import { createIcon } from '@chakra-ui/react';

export const CheckMarkThick = createIcon({
  displayName: 'CheckMarkThick',
  viewBox: '0 0 16 15',
  path: (
    <path
      id="Union_4"
      data-name="Union 4"
      d="M17957,22570l-6,6Zm-9,3,3,3Z"
      transform="translate(-17944.5 -22565)"
      fill="none"
      stroke="currentColor"
      strokeLinecap="round"
      strokeLinejoin="round"
      strokeWidth="2"
    />
  ),
});
